import AccueilInterface1Component from './components/accueil-interface-1/accueil-interface-1.component';
import AccueilInterface2Component from './components/accueil-interface-2/accueil-interface-2.component';
import AccueilInterface3Component from './components/accueil-interface-3/accueil-interface-3.component';
import EtatChainesComponent from './components/etat-chaines/etat-chaines.component';
import ReamenagementComponent from './components/reamenagement/reamenagement.component';
import AntenneAccessibleComponent from './components/antenne-accessible/antenne-accessible.component';
import FinAccueilComponent from './components/fin-accueil/fin-accueil.component';
import InterventionAntennisteComponent from './components/intervention-antenniste/intervention-antenniste.component';
import SignalementAntennisteComponent from './components/signalement-antenniste/signalement-antenniste.component';
import IncidentDetecteComponent from './components/incident-detecte/incident-detecte.component';
import AucunIncidentDetecteComponent from './components/aucun-incident-detecte/aucun-incident-detecte.component';
import DysfonctionnementInterfaceComponent from './components/dysfonctionnement-interface/dysfonctionnement-interface.component';
import ConclusionComponent from './components/conclusion/conclusion.component';

import modeReceptionFilter from './filters/mode-reception.filter';
import raisonDemandeFilter from './filters/raison-demande.filter';
import typePersonneFilter from './filters/type-personne.filter';
import routerConfig from './routes';

require('./accueil.scss');

const moduleName = 'dmattnt-accueil';
angular.module(moduleName, ['ui.router'])
  .component('dmattntAccueilInterface1', new AccueilInterface1Component())
  .component('dmattntAccueilInterface2', new AccueilInterface2Component())
  .component('dmattntAccueilInterface3', new AccueilInterface3Component())
  .component('dmattntEtatChaines', new EtatChainesComponent())
  .component('dmattntReamenagement', new ReamenagementComponent())
  .component('dmattntAntenneAccessible', new AntenneAccessibleComponent())
  .component('dmattntFinAccueil', new FinAccueilComponent())
  .component('dmattntInterventionAntenniste', new InterventionAntennisteComponent())
  .component('dmattntSignalementAntenniste', new SignalementAntennisteComponent())
  .component('dmattntIncidentDetecte', new IncidentDetecteComponent())
  .component('dmattntAucunIncidentDetecte', new AucunIncidentDetecteComponent())
  .component('dmattntDysfonctionnementInterface', new DysfonctionnementInterfaceComponent())
  .component('dmattntConclusion', new ConclusionComponent())
  .filter('labelModeReception', modeReceptionFilter)
  .filter('labelRaisonDemande', raisonDemandeFilter)
  .filter('labelTypePersonne', typePersonneFilter)
  .config(routerConfig);

export default {
  moduleName
};



// WEBPACK FOOTER //
// ./src/modules/accueil/accueil.module.js